// collections card-product-swatches image change js 

document.addEventListener("click", function (e) {

  const swatch = e.target.closest(".card-swatch");
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();

  const card = swatch.closest(".card-wrapper");
  if (!card) return;

  const image = card.querySelector(".collection-product-image");
  if (!image) return;

  const newImage = swatch.dataset.image;

  console.log("Title:", swatch.dataset.title);
  console.log("Image:", newImage);

  // Active class immediately
  card.querySelectorAll(".card-swatch").forEach(function (item) {
    item.classList.remove("active");
  });

  swatch.classList.add("active");

  // 500ms delay
  setTimeout(function () {

    if (newImage) {
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");

      image.src = newImage;
    }

  }, 500);

});

// collections card-product-swatches image change js 


// ===============================
// Know More Accordion
// ===============================
const knowMoreBtn = document.querySelector(".know-more-btn");

if (knowMoreBtn) {
  knowMoreBtn.addEventListener("click", function () {
    this.parentElement.classList.toggle("active");
  });
}


// ===============================
// FAQ Accordion
// ===============================
const faqButtons = document.querySelectorAll(".faq-question");

if (faqButtons.length) {
  faqButtons.forEach(button => {
    button.addEventListener("click", () => {
      const item = button.closest(".faq-item");

      document.querySelectorAll(".faq-item").forEach(faq => {
        if (faq !== item) {
          faq.classList.remove("active");
        }
      });

      item.classList.toggle("active");
    });
  });
}


// ===============================
// Currency Dropdown
// ===============================
document.addEventListener("click", function (e) {

  const btn = e.target.closest(".currency-btn");

  if (btn) {
    e.stopPropagation();

    const wrapper = btn.closest(".currency-wrapper");

    document.querySelectorAll(".currency-wrapper").forEach(item => {
      if (item !== wrapper) {
        item.classList.remove("active");
      }
    });

    wrapper.classList.toggle("active");
    return;
  }

  document.querySelectorAll(".currency-wrapper").forEach(item => {
    item.classList.remove("active");
  });

});



document.addEventListener("DOMContentLoaded", function () {

  function updateVariantLabels() {
    updateOption("Diamond Shape", ".diamondshape_variant_select");
    updateOption("Metal", ".metal_variant_select");
    updateOption("Gold Color", ".metal_variant_select");
    updateOption("Ring Size", ".ringsize_variant_select");
  }

  function updateOption(optionName, targetSelector) {

    const target = document.querySelector(targetSelector);
    if (!target) return;

    let value = "";

    // -----------------------------
    // Radio Buttons
    // -----------------------------
    const radio = document.querySelector(
      `input[data-option-name="${optionName}"]:checked`
    );

    if (radio) {
      value = radio.value;
    }

    // -----------------------------
    // Shopify Variant Dropdown
    // Example:
    // name="options[Ring Size]"
    // -----------------------------
    if (!value) {
      const variantSelect = document.querySelector(
        `select[name="options[${optionName}]"]`
      );

      if (variantSelect) {
        value = variantSelect.value;
      }
    }

    // -----------------------------
    // Shopify Line Item Property
    // Example:
    // name="properties[Ring Size]"
    // -----------------------------
    if (!value) {
      const propertySelect = document.querySelector(
        `select[name="properties[${optionName}]"]`
      );

      if (propertySelect) {
        value = propertySelect.value;
      }
    }

    // -----------------------------
    // Fallback by Label Text
    // -----------------------------
    if (!value && optionName === "Ring Size") {
      const ringSelect = document.querySelector(".ring-size-picker select");

      if (ringSelect) {
        value = ringSelect.value;
      }
    }

    // -----------------------------
    // Update Label
    // -----------------------------
    if (value) {
      target.textContent = value;

      if (target.parentElement) {
        target.parentElement.style.display = "";
      }

    } else {

      target.textContent = "";

      if (target.parentElement) {
        target.parentElement.style.display = "none";
      }
    }
  }

  // Initial Load
  updateVariantLabels();

  // Any Change
  document.addEventListener("change", function () {
    setTimeout(updateVariantLabels, 50);
  });

  // Shopify Variant Change
  document.addEventListener("variant:change", function () {
    setTimeout(updateVariantLabels, 50);
  });

  // Dawn/Product Info Update
  document.addEventListener("variant:changed", function () {
    setTimeout(updateVariantLabels, 50);
  });

  // Mutation Observer (AJAX themes)
  const variantContainer = document.querySelector("variant-selects");

  if (variantContainer) {
    const observer = new MutationObserver(function () {
      updateVariantLabels();
    });

    observer.observe(variantContainer, {
      childList: true,
      subtree: true,
      attributes: true
    });
  }

});



// Shopify Variant Change 
document.addEventListener("DOMContentLoaded", function () {

    function setText(selector, value) {
        document.querySelectorAll(selector).forEach(function (el) {
            el.textContent = value || "-";
        });
    }

    function updateVariantData(variantId) {

        if (!window.productVariants) return;

        const variant = window.productVariants.find(function (v) {
            return Number(v.id) === Number(variantId);
        });

        if (!variant) return;

        /* -------------------------
           Variant Metafields
        --------------------------*/

        setText(".style_no", variant.style_no);

        setText(".certification", variant.certification);

        setText(".diamond_type", variant.diamond_type);

        setText(".gram_weight", variant.gram_weight);

        setText(".carat_weight", variant.carat_weight);

        setText(".color_clarity", variant.color_clarity);
    }

    function getCurrentVariantId() {
        let input = document.querySelector('input[name="id"]');
        if (input) return input.value;
        let select = document.querySelector('select[name="id"]');
        if (select) return select.value;
        return null;
    }

    /* First Load */
    let currentVariant = getCurrentVariantId();
    if (currentVariant) {
        updateVariantData(currentVariant);
    }

    /* Variant Change */
    document.addEventListener("change", function () {
        let currentVariant = getCurrentVariantId();
        if (currentVariant) {
            updateVariantData(currentVariant);
        }
    });

    /* Mutation Observer */
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
        new MutationObserver(function () {
            updateVariantData(variantInput.value);
        }).observe(variantInput, {
            attributes: true,
            attributeFilter: ["value"]
        });
    }

    /* Dawn Theme */
    document.addEventListener("variant:change", function (event) {
        if (event.detail && event.detail.variant) {
            updateVariantData(event.detail.variant.id);
        }
    });
});

// Shopify Variant Change 









document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product__description').forEach(function (description) {

    const content = description.querySelector('.description-content');
    const button = description.querySelector('.description-read-more');

    if (!content || !button) return;

    button.addEventListener('click', function () {

      description.classList.toggle('is-expanded');

      if (description.classList.contains('is-expanded')) {
        button.textContent = 'Read Less';
      } else {
        button.textContent = 'Read More';
      }

    });

  });
});



// product-template offer js start
document.querySelectorAll('.offers-box').forEach(section => {

  /* =============================
     ACCORDION TOGGLE
  ============================== */
  section.querySelectorAll('.offer-top').forEach(top => {
    top.addEventListener('click', () => {

      const item = top.closest('.offer-item');
      const bottom = item.querySelector('.offer-bottom');
      const arrow = item.querySelector('.arrow');

      // Close others inside same section only
      section.querySelectorAll('.offer-bottom').forEach(el => {
        if (el !== bottom) {
          el.style.display = 'none';
          el.closest('.offer-item')
            .querySelector('.arrow')
            .style.transform = 'rotate(0deg)';
        }
      });

      // Toggle current
      const isOpen = bottom.style.display === 'flex';

      bottom.style.display = isOpen ? 'none' : 'flex';
      arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
    });
  });


  /* =============================
     COPY COUPON
  ============================== */
  section.querySelectorAll('.copy-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      const code = btn.dataset.code;

      navigator.clipboard.writeText(code);

      btn.innerText = 'Copied';
      setTimeout(() => btn.innerText = 'Copy Code', 1500);
    });
  });


  /* =============================
     MORE OFFERS TOGGLE
  ============================== */
  const moreOffers = section.querySelector('.more-offers');
  const toggleBtn = section.querySelector('.toggle-btn');

  if (moreOffers && toggleBtn) {

    const offerItems = moreOffers.querySelectorAll('.offer-item');
    const offerCount = offerItems.length;

    // Hide initially
    moreOffers.style.display = 'none';

    // Hide button if no offers
    if (offerCount === 0) {
      toggleBtn.style.display = 'none';
      return;
    }

    function updateButtonText(isOpen) {
      if (isOpen) {
        toggleBtn.innerText = 'Close';
      } else {
        toggleBtn.innerText =
          offerCount === 1
            ? `+${offerCount} More Offer`
            : `+${offerCount} More Offers`;
      }
    }

    updateButtonText(false);

    toggleBtn.addEventListener('click', () => {
      const isOpen = moreOffers.style.display === 'block';

      moreOffers.style.display = isOpen ? 'none' : 'block';
      updateButtonText(!isOpen);
    });
  }

});
// product-template offer js end



// variant Metal Hover change js start
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.metal-picker').forEach(function (picker) {
    const selectedValue = picker.querySelector('[data-selected-value]');
    const radios = picker.querySelectorAll('input[type="radio"]');

    if (!selectedValue || !radios.length) return;

    // Get currently selected metal
    function updateSelectedValue() {
      const checkedRadio = picker.querySelector(
        'input[type="radio"]:checked'
      );

      if (checkedRadio) {
        selectedValue.textContent = checkedRadio.value;
      }
    }

    // Hover: temporarily show hovered metal
    radios.forEach(function (radio) {
      const label = picker.querySelector(
        'label[for="' + radio.id + '"]'
      );

      if (!label) return;

      label.addEventListener('mouseenter', function () {
        selectedValue.textContent = radio.value;
      });

      label.addEventListener('mouseleave', function () {
        updateSelectedValue();
      });

      // Click: show the newly selected metal
      label.addEventListener('click', function () {
        setTimeout(updateSelectedValue, 0);
      });

      // Keyboard or other selection changes
      radio.addEventListener('change', updateSelectedValue);
    });

    // Initial selected value
    updateSelectedValue();
  });
});
// variant Metal Hover change js end